// react
import { useContext } from 'react';

// context
import { ContextSupplier, ContextSupplierUsers } from '../Supplier.context';

// mui
import { Container } from '@mui/material';

// tables
import { TableUsers } from '../../../tables/cards/TableUsers/TableUsers';

export const Users = () => {
	// context
	const { supplier } = useContext(ContextSupplier);
	const { isLoadingUsers, paginationUsers, refetchUsers, users } = useContext(ContextSupplierUsers);

	return (
		<section>
			<Container maxWidth={false}>
				<TableUsers
					entity={supplier}
					frame="SUPPLIER"
					isLoading={isLoadingUsers}
					pagination={paginationUsers}
					refetchUsers={refetchUsers}
					users={users}
				/>
			</Container>
		</section>
	);
};
